import { Button } from '@mui/material';
import { useGame } from 'contexts/Game/Game';
import { usePage } from 'contexts/Page/Page';
import { useSounds } from 'contexts/Sounds/Sounds';
import { useMemo } from 'react';
import { MaterialSymbol } from 'react-material-symbols';

const disabledRounds = ['init', 'next', 'end'];

export default function AllInButton() {
    const game = useGame();
    const page = usePage();
    const sounds = useSounds();

    const { allInButtonLesson, disableAllInButton, incorrectActionLesson, skipDeal } = game.lessonProps;

    const disabled = useMemo(() => {
        return (
            !allInButtonLesson &&
            (disableAllInButton || game.remainingCosts > game.budget || disabledRounds.includes(game.round))
        );
    }, [game.remainingCosts, game.round, allInButtonLesson, disableAllInButton, game.budget]);

    function handleClick() {
        if (!game.loading && game.ready) {
            sounds.play('submit');

            // Perform action
            if (incorrectActionLesson) {
                game.interceptAction('allIn', allInButtonLesson, skipDeal);
            } else if (!disableAllInButton) {
                game.allIn(!allInButtonLesson, skipDeal);
            }

            // Show lesson
            if (incorrectActionLesson) {
                page.show(incorrectActionLesson);
            } else if (allInButtonLesson) {
                page.show(allInButtonLesson);
            }
        }
    }

    return (
        <Button
            disabled={disabled}
            startIcon={<MaterialSymbol aria-hidden icon="input_circle" size={23} />}
            tabIndex={6}
            variant="text"
            onClick={handleClick}
        >
            All In ${game.remainingCosts}
        </Button>
    );
}
